module.exports = "<section class=\"nn-google-ad--{{ getAdUnitType() }}\"><div class=\"js-ad-container container container--large\" id=\"div-gpt-ad-{{ $id }}\" ng-show=show></div></section>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-modules/nn-google-ad/nn-google-ad.directive.html
// module id = 996
// module chunks = 0